import type { IAnimatedRefreshIconProps } from './helpers';

export const AnimatedRefreshIcon = ({ variant = 'static', ...rest }: IAnimatedRefreshIconProps) => (
	<svg
		{...rest}
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		style={{
			display: 'inline-block',
			transformOrigin: 'center',
			animation: variant === 'spin' ? 'spin 1s linear infinite' : 'none',
		}}
	>
		<path
			opacity='0.4'
			d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
			fill='var(--color-neutral-50)'
		/>
		<path
			d='M16.7586 11.9301C16.3386 11.8601 15.9686 12.1601 15.9086 12.5701C15.7886 13.4401 15.3986 14.2201 14.7986 14.8201C13.4186 16.2001 11.2786 16.3401 9.72861 15.2701H10.4786C10.8886 15.2701 11.2286 14.9301 11.2286 14.5201C11.2286 14.1101 10.8886 13.7701 10.4786 13.7701H7.80859C7.39859 13.7701 7.05859 14.1101 7.05859 14.5201V17.1901C7.05859 17.6001 7.39859 17.9401 7.80859 17.9401C8.21859 17.9401 8.55859 17.6001 8.55859 17.1901V16.2501C9.55859 17.0601 10.7686 17.4901 11.9886 17.4901C13.3886 17.4901 14.7886 16.9601 15.8586 15.8901C16.6886 15.0601 17.2186 13.9901 17.3886 12.7901C17.4586 12.3601 17.1686 11.9801 16.7586 11.9301Z'
			fill='#022745'
		/>
		<path
			d='M7.33944 12.0803C7.70944 12.0803 8.02943 11.8103 8.07943 11.4403C8.19943 10.5703 8.58944 9.79031 9.18944 9.19031C10.5694 7.81031 12.7095 7.6703 14.2595 8.7403H13.5095C13.0995 8.7403 12.7595 9.0803 12.7595 9.4903C12.7595 9.9003 13.0995 10.2403 13.5095 10.2403H16.1794C16.5894 10.2403 16.9294 9.9003 16.9294 9.4903V6.82031C16.9294 6.41031 16.5894 6.07031 16.1794 6.07031C15.7694 6.07031 15.4294 6.41031 15.4294 6.82031V7.76031C13.2794 6.02031 10.1295 6.1303 8.13946 8.1203C7.30946 8.9503 6.77943 10.0203 6.60943 11.2203C6.54943 11.6303 6.83944 12.0103 7.24944 12.0703C7.26944 12.0803 7.30944 12.0803 7.33944 12.0803Z'
			fill='#022745'
		/>
	</svg>
);
